import { combineReducers } from 'redux';
import auth from './authReducer';
import call from './callReducer';
import chats from './chatsReducer';
import cls from './clsReducer';
import feed from './feedReducer';
import flashphoner from './flashphonerReducer';
import followers from './followersReducer';
import foreignUser from './foreignUserReducer';
import hardware from './hardwareReducer';
import popup from './popupReducer';
import post from './postReducer';
import profile from './profileReducer';
import restoreAccount from './restoreAccountReducer';
import savedSearch from './savedSearchReducer';
import searchItem from './searchItemReducer';
import search from './searchReducer';
import signUp from './signUpReducer';
import theme from './themeReducer';
import upload from './uploadReducer';
import user from './userReducer';

export default combineReducers({
  auth,
  call,
  chats,
  cls,
  feed,
  flashphoner,
  followers,
  foreignUser,
  hardware,
  popup,
  post,
  profile,
  restoreAccount,
  savedSearch,
  search,
  searchItem,
  signUp,
  theme,
  upload,
  user,
});
